import { render } from "./App.vue?vue&type=template&id=3ca0d7f8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3ca0d7f8&lang=css"

import exportComponent from "D:\\code\\miao_up_up_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__